import { defaultIconProps, IconProps } from './IconProps';

export const IconCloud: import('react').FC<IconProps> = ({ size, color, strokeWidth = 1.5, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M5.41675 12.8334C3.34568 12.8334 1.66675 11.1544 1.66675 9.08335C1.66675 7.13038 3.15967 5.5261 5.06653 5.34949C5.45659 2.9768 7.51695 1.16669 10.0001 1.16669C12.4832 1.16669 14.5436 2.9768 14.9336 5.34949C16.8405 5.5261 18.3334 7.13038 18.3334 9.08335C18.3334 11.1544 16.6545 12.8334 14.5834 12.8334C10.9252 12.8334 8.6195 12.8334 5.41675 12.8334Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconCloud.defaultProps = defaultIconProps;
